import React, { Component } from "react"
import Footer from "../components/ladakh/footer/footer"
import ReactGA from "react-ga"
import HeaderStories from "../components/headerStories"
import authorImg from "../images/author1.jpg"
import blogPhoto from "../images/item1.jpg"
import hamburgerMenu from "../images/stories/menu.svg"
import dots from "../images/stories/dots.png"
import StoriesList from "../components/stories/index"
import "../style/stories.css"
import StoriesCategory from "../components/stories/categories"
class Stories extends Component {
  constructor(props) {
    super(props)
    this.state = {
      FilterList: [],
      categories: false,
      feedback: false,
    }
  }
  test = (value, season) => {
    console.log("value", value)
    console.log("seas", season)
    let filters = value.stories.filter(
      person => person.item.stories === season || person.item.country === season
    )
    this.setState({
      FilterList: filters,
    })
  }

  categories = () => {
    this.setState(prevState => ({
      categories: !prevState.categories,
    }))
  }

  feedback = () => {
    this.setState(prevState => ({
      feedback: !prevState.feedback,
    }))
  }

  render() {
    const trackingId = "UA-24117780-3" // Replace with your Google Analytics tracking ID
    ReactGA.initialize(trackingId)
    console.log("NEW LIST", this.state.FilterList)
    return (
      <div className="news-page stories-page">
        <HeaderStories />

        <div className="container stories-main" id="stories">
          <div
            className={
              this.state.categories
                ? "mobile-left-side left-side active"
                : "mobile-left-side left-side"
            }
          >
            <div className="close-categori" onClick={this.categories}>
              x
            </div>
            <div className="box">
              <h3>Stories</h3>
              <StoriesCategory test={this.test} />
            </div>
          </div>

          {/* right */}
          <div
            className={
              this.state.feedback
                ? "mobile-right-side right-side active"
                : "mobile-right-side right-side"
            }
          >
            <div className="close-categori" onClick={this.feedback}>
              x
            </div>
            <h3>Feedback</h3>
            <div className="user">
              <div className="top">
     
              </div>
              <i>
                Great Guides is a great concept... a must-see for anyone
                interested in travel, people, culture and nature! Thanks for all
                the hard work you've put into this incredible resource.
              </i>
            </div>
            <div className="quote">
              <h3>Quote of the Day</h3>
              <i>The secret of success is constancy to purpose.</i>
              <b>— Benjamin Disraeli</b>
            </div>
          </div>
          <div className="stori-category-feedback">
            <div className="cat-story" onClick={this.categories}>
              <img src={hamburgerMenu} alt="menu" /> Choose Type of story,
              Country
            </div>
            <div className="feedback-small" onClick={this.feedback}>
              <img src={dots} alt="dots" />
            </div>
          </div>
          <div className="left-side">
            <div className="box">
              <StoriesCategory test={this.test} />
            </div>
          </div>
          <div className="middle-content">
            <StoriesList filterList={this.state.FilterList} />
          </div>
          <div className="right-side">
            <h3>Feedback</h3>
            <div className="user">
              <div className="top">
               
              </div>
              <i>
               <b>An outstanding initiative </b> 
               <br/> I have been following the development of 'great guides' and think it is an outstanding initiative. <br/> - Prof Andy Dawes
               
              </i>
            </div>
            <div className="quote">
              <h3>Quote of the Day</h3>
              <i>The secret of success is constancy to purpose.</i>
              <b>— Benjamin Disraeli</b>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

export default Stories
